// src/app/Shared/activity/activity.storage.ts
export type ActivityStorageState = {
  readIds: string[];
  dismissedIds?: string[];
  lastSeenAt?: string; // ISO
  lastUnreadCount?: number;
};

const KEY = 'hc.activity.v1';

export function loadActivityState(): ActivityStorageState {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { readIds: [] };
    const parsed = JSON.parse(raw) as ActivityStorageState;
    return {
      readIds: Array.isArray(parsed.readIds) ? parsed.readIds : [],
      dismissedIds: Array.isArray(parsed.dismissedIds) ? parsed.dismissedIds : [],
      lastSeenAt: parsed.lastSeenAt,
      lastUnreadCount: typeof parsed.lastUnreadCount === 'number' ? parsed.lastUnreadCount : 0,
    };
  } catch {
    return { readIds: [], dismissedIds: [], lastUnreadCount: 0 };
  }
}

export function saveActivityState(state: ActivityStorageState): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // ignore
  }
}
